import requestFunctions from "../../functions/requestFunctions";


export const state = {
  DICTIONARIES_ITEM: {},
  DICTIONARIES_LIST: [],
  DICTIONARIES_TABLE_DATA: [],
  DICTIONARIES_LIST_DATA: [],
  DICTIONARIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_DICTIONARIES_ITEM: (state) => {
    return state.DICTIONARIES_ITEM;
  },
  GET_DICTIONARIES_LIST: (state) => {
    return state.DICTIONARIES_LIST;
  },
  GET_DICTIONARIES_TABLE_DATA: (state) => {
    return state.DICTIONARIES_TABLE_DATA;
  },
  GET_DICTIONARIES_LIST_DATA: (state) => {
    return state.DICTIONARIES_LIST_DATA;
  },
  GET_DICTIONARIES_TOTAL_ROWS: (state) => {
    return state.DICTIONARIES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_DICTIONARIES_ITEM(state, item) {
    state.DICTIONARIES_ITEM = item;
  },

  UPDATE_DICTIONARIES_LIST(state, list) {
    
    state.DICTIONARIES_LIST = list.data;

    state.DICTIONARIES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.DICTIONARIES_TABLE_DATA = [];
    state.DICTIONARIES_LIST_DATA = [];

    list.forEach(el => {

      let user_data = '';
    
      if(el.profile_fullname !== null){
        user_data = el.profile_fullname;
      }
      
      if(el.user_phone !== null ){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_phone;
      }

      let dev_data = '';

      if(el.dev_profile_fullname !== null){
        dev_data = el.dev_profile_fullname;
      }
      
      if(el.dev_phone !== null ){
        if(dev_data !== ''){
          dev_data = dev_data + ', ';
        }
        dev_data = dev_data + el.dev_phone;
      }

      state.DICTIONARIES_TABLE_DATA.push({
        'name' : el.name,
        'uuid' : el.uuid,
        'id' : el.id,
        'user_data' : user_data,
        'dev_data' : dev_data,
        'updated_at' : el.updated_at,
        'owner_id': el.owner_id,
        'user_id': el.user_id
      });

      state.DICTIONARIES_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_DICTIONARIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dictionaries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DICTIONARIES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_DICTIONARIES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/dictionaries';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_DICTIONARIES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_DICTIONARIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dictionaries';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_DICTIONARIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dictionaries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_DICTIONARIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/dictionaries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}